module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-BlackItalic.0dfd256.woff";